import { useEffect } from 'react';

const DotLottiePlayer: React.FC<{src?: string; autoplay?: boolean; controls?: boolean; loop?: boolean; mode?: 'normal' | 'bounce'; style?: string}> = (props) => {
  // Load lottie player web component
  useEffect(() => void import('@dotlottie/player-component'), []);
  return (<dotlottie-player {...props} />);
};

export default DotLottiePlayer;
